import React, {Component} from 'react';
import _ from "underscore";
import {Link} from 'react-router-dom';
import jsonata from "jsonata";

class Front extends Component {


    render() {
        const entry = this.props.entry;
        const photo = entry.fields[this.props.configuration.display.front.photo];


        let photoUrl = null;
        if (photo && photo[0]) {
            if (photo[0].thumbnails) {
                photoUrl = photo[0].thumbnails.large.url;
            } else {
                photoUrl = photo[0].url;
            }
        }

        let display = [];
        _.each(this.props.configuration.display.front.fields, (config, index) => {
            try {
                let exp = jsonata(config.field);
                let value = exp.evaluate(entry);
                if (!value && config.fallback) {
                    exp = jsonata(config.fallback);
                    value = exp.evaluate(entry);
                }
                console.log(value);
                if (config.type === "title") {
                    display.push(
                        (
                            <div className="Voting-Group-Front-Element-Content-Title"
                                 key={entry.id + '-' + config.type + '-' + index}>
                                {value}
                            </div>
                        )
                    );
                } else if (config.type === "text" && value) {
                    display.push(
                        (
                            <div className="Voting-Group-Front-Element-Content-Line"
                                 key={entry.id + '-' + config.type + '-' + index}>
                                {config.icon ? <i className={config.icon}/> : null}
                                {value}
                            </div>
                        )
                    );

                } else if (config.type === "link" && value) {
                    display.push(
                        (
                            <div className="Voting-Group-Front-Element-Content-Line"
                                 key={entry.id + '-' + config.type + '-' + index}>
                                {config.icon ? <i className={config.icon}/> : null}
                                {config.label ? <b>{config.label}</b> : null}
                                <a href={config.link === "value" ? value : config.link} target="_blank">
                                    {config.content === "value" ? value : config.content}
                                </a>
                            </div>
                        )
                    );

                }
            } catch (e) {
                console.log(e)
            }
        });

        let shortMode = false;
        if ("voting" in this.props.configuration) {
            shortMode = !!this.props.configuration.voting.short;
        }

        let classNameContainer = 'Voting-Group-Front-Element';
        let classNamePicture = "Voting-Group-Front-Element-Picture";
        let classNameContent = "Voting-Group-Front-Element-Content";

        if (shortMode) {
            classNameContent += " autoHeight";
            classNamePicture += " contain";
        }

        if (display.length === 0) {
            classNameContainer += ' noBorderRadius whiteBg';
            classNamePicture += ' ';
        }

        let detailsEnabled = true;
        if ("voting" in this.props.configuration) {
            detailsEnabled = this.props.configuration.voting.details;
        }

        if (detailsEnabled) {
            return (
                <Link to={"/record/" + this.props.entry.id}>
                    <div className={classNameContainer}>
                        {this.renderImage(classNamePicture, photoUrl)}
                        {display.length > 0 ? (
                            <div className={classNameContent}>
                                {display}
                            </div>
                        ) : null}
                    </div>
                </Link>
            );
        } else {
            return (
                <div className={classNameContainer}>
                    {this.renderImage(classNamePicture, photoUrl)}
                    {display.length > 0 ? (
                        <div className={classNameContent}>
                            {display}
                        </div>
                    ) : null}
                </div>
            );
        }
    }

    renderImage(classNamePicture, photoUrl) {
        const entry = this.props.entry;
        const photoLinkConfig = this.props.configuration.display.front.photoLink;
        let photoLink = null;
        if (photoLinkConfig) {
            try {
                let exp = jsonata(photoLinkConfig);
                photoLink = exp.evaluate(entry);
            } catch (e) {
            }
        }

        if (photoLink !== null) {
            return (
                <a href={photoLink} target="_blank">
                    <div className={classNamePicture}
                         style={{backgroundImage: 'url("' + (photoUrl) + '")'}}>
                        {this.renderVotingButton()}
                    </div>
                </a>
            )
        } else {
            return (
                <div className={classNamePicture}
                     style={{backgroundImage: 'url("' + (photoUrl) + '")'}}>
                    {this.renderVotingButton()}
                </div>
            )
        }

    }

    renderVotingButton() {
        const entry = this.props.entry;

        let votingEnabled = true;
        if ("voting" in this.props.configuration) {
            votingEnabled = this.props.configuration.voting.enabled;
        }

        if (votingEnabled) {
            return (
                <button onClick={() => {
                    this.props.onAskForVote();
                    return false;
                }}>
                    {entry.id in this.props.voting.stats ? this.props.voting.stats[entry.id] : 0}
                    <i className="fas fa-heart"/>
                </button>
            )
        } else {
            return null;
        }
    }
}

export default Front;


// WEBPACK FOOTER //
// ./src/Components/Voting/Front.js